/* eslint-disable id-length */
import Axios from 'axios'

const A = 'a'
const B = 'b'

export default {

    call : async url => {
        return Axios({
            method: 'get',
            headers: { 'content-type': 'application/json'},
            url
        })
            .then(result => result.data.beta ? B : A)
            .catch(() => A)
    },

    A,
    B

}
